<template>
  <div class="inner-box">
    <img src="./../assets/image/apply.png" alt="" />
    <p class="font-20 color-333">投递成功</p>
    <p class="font-14 color-666">
      您的简历已收到，经内部审核后，若简历符合要求，一周内会有HR与您尽快联系！
    </p>
    <el-button type="primary" size="small" round @click="goPosition"
      >继续浏览职位</el-button
    >
  </div>
</template>

<script>
export default {
  methods: {
    goPosition() {
      this.$router.push("/position");
    },
  },
};
</script>

<style lang="scss" scoped>
.inner-box {
  width: 451px;
  padding: 80px 0 163px;
  margin: 0 auto;
  text-align: center;
  .color-333 {
    margin: 24px 0 16px;
  }
  .el-button {
    width: 120px;
    margin-top: 30px;
  }
}
</style>